import { AllStatuses, AllStatusesTypes } from '../../interfaces';

export const isBroadcastReadonly = (
  broadcastStatus: AllStatusesTypes,
): boolean =>
  (
    [
      AllStatuses.PENDING_APPROVAL,
      AllStatuses.APPROVED,
      AllStatuses.PUBLISHED,
    ] as AllStatusesTypes[]
  ).includes(broadcastStatus);
